import { useQuery } from '@apollo/react-hooks';
import { gql } from 'graphql-tag';
import moment from 'moment';
import { useContext } from 'react';
import { useParams } from 'react-router-dom';
import { useSearchInput } from 'hooks/useSearchInput';
import { AppContext } from 'shared/AppContext';

export const GET_ACCOUNT_EXPIRED_CREDITS = gql`
  query GetUserExpiredCreditsByAccount($creditsInput: GetUserCreditsInput!) {
    getUserExpiredCreditsByAccount(input: $creditsInput) {
      count
      results {
        id
        user {
          formatted_name
        }
        amount
        date
        issued_by {
          formatted_name
        }
      }
    }
  }
`;

export function useGetUserExpiredCreditsByAccount() {
  const { id: user_id } = useParams();
  const {
    state: { accountId },
  } = useContext(AppContext);
  const { input: search } = useSearchInput();

  // Get year from URL search params, default to current year
  const thisYear = Number(moment().format('YYYY'));
  const yearFilter = search.year ? Number(search.year) : thisYear;

  // Spread search but exclude year (we handle it separately as integer)
  const { ...searchWithoutYear } = search;

  const result = useQuery(GET_ACCOUNT_EXPIRED_CREDITS, {
    variables: {
      creditsInput: {
        account_id: Number(accountId),
        user_id: Number(user_id),
        ...searchWithoutYear,
        year: yearFilter,
      },
    },
    fetchPolicy: 'cache-and-network',
  });

  return { ...result, res: result.data };
}
